exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".test-container{margin:18px auto}.test-step-item{min-height:300px;text-align:center}.test-container h3{text-shadow:0 1px 2px rgba(0,0,0,.6)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/LineTest/LineTest.scss
 ** module id = 1201
 ** module chunks = 0
 **/